var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 590.57 650.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:rgba(207, 215, 245, 0.2);}.cls-2{fill:#d18c65;}.cls-3{fill:#e0e0e0;}.cls-4{fill:#a4a4a4;}.cls-5{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.04px;}.cls-6{fill:#fff;}.cls-7{fill:#e49d75;}.cls-8{fill:#2495a7;}.cls-9{fill:#17a2b8;}.cls-10{fill:#ffc78e;}.cls-11{fill:#ffd98e;}.cls-12{fill:#ffe4ad;}.cls-13{fill:#495057;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social-feed-colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.3,136.63c35.14,41.53,31.15,115.81,16.77,175.4C565.53,371.77,540.45,417,505.31,471S425,587.9,365.22,602.44,231.35,583,166.18,529,44.61,400.68,29.6,311.55c-15-89.3,11.18-193.61,76.36-235.14s169.48-20.29,258.78-5.27C453.87,86.31,528.15,95.1,563.3,136.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.54,201.69c-1.36,6.65.12,54.26-1.85,61.77s-23.83,99.29-23.83,99.29l34.77-9.61s12.19-26.79,16.61-50.91C314.13,281,313.57,202.06,284.54,201.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.79 222.71 228.23 222.71 215.31 173.71 237.88 173.71 250.79 222.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 297.84,
    y: 358.96,
    width: 245.11,
    height: 245.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 343.23,
    cy: 407.87,
    r: 24.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 397.28,
    x2: 513.92,
    y2: 397.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 418.45,
    x2: 444.21,
    y2: 418.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 470.93,
    x2: 513.92,
    y2: 470.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 492.1,
    x2: 444.21,
    y2: 492.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 544.57,
    x2: 513.92,
    y2: 544.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 388.69,
    y1: 565.74,
    x2: 444.21,
    y2: 565.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 343.23,
    cy: 481.51,
    r: 24.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 343.23,
    cy: 555.16,
    r: 24.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "63.83 589.56 86.88 576.29 101.46 602.99 74.61 616.25 63.83 589.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "232.94 576.29 238.08 605.8 269.25 600.5 258.97 567.01 232.94 576.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M310.08,341.25c-9.18.5-159.81,33.21-161.77,40.88-16.13,62.92,76,195,82.77,199,7.3-1.76,32.21-10.44,32.21-10.44l-5.72-88.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.4 620.39 63 581.93 12.93 534.02 0 541.14 49.57 636.14 81.4 620.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.61 593.43 229.63 600.91 170.09 636.38 173.52 650.75 278.3 628.31 271.61 593.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M426.28,302.23c5.86,4.69,12,25.83,12.71,33,7.67,83.18-129.24,132.16-148.2,140.38-18,15.05-175,130.79-184.57,133.53s-25.22-34-23.85-38.91S313.85,334,313.85,334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M316.19,152.5c-19.37-9.57-37.28,42.92-35.56,48.93s19.5,7.73,24,7.73S316.19,152.5,316.19,152.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M353.33,122.39c70.7,0,77.37,168.55,76.57,180.05-7.14,23.44-92.78,51.6-119.14,36.19C268.93,240.55,288.2,122.39,353.33,122.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M423.86,205.49c3.95,6.74,12.45,50.66,11.6,56.39s-14,20.19-18.68,20.51c-66.54,4.52-138.71-22.07-152.2-29.54-28.22-2.25-44.92-12.44-44.92-27.34,0-8.8,4.88-15.14,7.57-15.14,5.1,0,14.16,8.79,15.26,11.36-2.2-4.52-9.1-12.82-3.42-12.82,1.58,0,14.4,17.92,21.36,22.27s107.41,8,127.55,15.32c-2.57-5.12-9.77-23.68-9.89-26.36S423.86,205.49,423.86,205.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 187.22,
    y: 97.1,
    width: 53.72,
    height: 53.72,
    rx: 7.68,
    transform: "translate(-20.06 44.12) rotate(-11.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.3,118.14l-1.2-6a4.58,4.58,0,0,0-5.4-3.61l-3.33,14.73,3.29,16.53,17-3.37a3.06,3.06,0,0,0,2.5-3.15l-.61-14a3.07,3.07,0,0,0-3.21-2.92,4.1,4.1,0,0,0-.49.06Zm-6.64,21.63-4.51.9a3.06,3.06,0,0,1-3.6-2.41l-2.1-10.52a3.07,3.07,0,0,1,2.41-3.61l4.51-.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "221.78 162.66 226.46 148.88 212.18 151.72 221.78 162.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M373.66,135.82c30.61-11.22,54.81,59.5,53.82,68.46s-50,24.65-55.52,21.41S343.32,146.94,373.66,135.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.33,91.72c-.33,4.25,2.26,28,6.31,35.75-1.79,3.52-20.19,13.75-29,11.56-1.2-6.58-4.39-24.25-7-29.63C330.35,106.94,355.33,91.72,355.33,91.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 319.82,
    cy: 63.69,
    rx: 40.14,
    ry: 50.31,
    transform: "translate(-5.64 84.17) rotate(-14.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M338.67,63.05c-2.22.12-10.69-4.2-12.57-17.16-6.11-1-33.05,1.87-47.17,13-5.23,2-9.47,3.67-17.38,3.67-3.75,0-6.93-3.92-6.93-6.61,0-7.41,3.18-14.59,12.47-15.07-7.82-.17-15.07-5-15.07-8.56,0-4.73,10.75-19.24,29.5-12.88-4.4-3.18-9.37-6.28-9.37-9.29C272.15,5,279.56,0,292.52,0c20.05,0,41.9,8.31,46.62,14.26,2.2-1.14,5-3.26,10.36-3.26,13.36,0,17.84,43.28,12.06,57.79a12.69,12.69,0,0,1-4.71,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.27,64a9.87,9.87,0,1,1,5,12.15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.115d45fd115885c4fc0dd78f88783dc6.svg";
export { ForwardRef as ReactComponent };